import { render, staticRenderFns } from "./Mxik.vue?vue&type=template&id=10f12ca5"
import script from "./Mxik.vue?vue&type=script&lang=js"
export * from "./Mxik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports